import { Link, useLocation } from "react-router-dom";
import "./drejtoria.css";
import { useEffect, useState } from "react";
import { drejtoriaData } from "./drejtoriaData.js";
import axios from "axios";

const Drejtoria = () => {
  const [historikuImages, setHistorikuImages] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const pagePath = useLocation();

  const fetchHistorikuImages = async () => {
    try {
      const response = await axios.get(
        "https://api.arkiva.gov.al/api/historiku/images"
      );
      setHistorikuImages(response.data.images);
    } catch (error) {
      console.error("Error fetching historiku images:", error);
    }
  };

  useEffect(() => {
    if (pagePath.pathname === "/drejtoria/historiku") {
      fetchHistorikuImages();
    }
  }, [pagePath.pathname]);

  const pageData = drejtoriaData.find(
    (item) => item.path === pagePath.pathname
  );

  if (!pageData) {
    return <div>Page not found</div>;
  }

  const isStrukturaPath = pagePath.pathname === "/drejtoria/struktura";
  const content = pageData.content || [];
  const leftItems = isStrukturaPath ? content.slice(0, 4) : [];
  const rightItems = isStrukturaPath ? content.slice(4, 8) : [];

  const openModal = (index) => {
    setCurrentImageIndex(index);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const nextSlide = () => {
    setCurrentImageIndex(
      (prevIndex) => (prevIndex + 1) % historikuImages.length
    );
  };

  const prevSlide = () => {
    setCurrentImageIndex((prevIndex) =>
      prevIndex === 0 ? historikuImages.length - 1 : prevIndex - 1
    );
  };

  const renderPageContent = () => {
    if (pagePath.pathname === "/drejtoria/historiku") {
      return (
        <div className="page-content-historiku">
          <div className="left-content-historiku">{pageData.leftContent}</div>
          <div className="right-content-historiku">
            <button onClick={() => openModal(0)}>Galeri</button>
          </div>
        </div>
      );
    } else if (pagePath.pathname === "/drejtoria/kla-kpe-kdzh-kqe") {
      return (
        <>
          {pageData.sections.map((section, idx) => (
            <div
              className={`page-content ${
                section.title === "Këshilli i Lartë i Arkivave"
                  ? "kla"
                  : section.title ===
                    "Komisioni i Deklasifikimit dhe Zhvlerësimit të Informacionit të klasifikuar Sekret Shtetëror"
                  ? "kdzh"
                  : "kqe"
              }`}
              key={idx}
            >
              {section.title !== "Këshilli i Lartë i Arkivave" && (
                <div className="page-header">
                  <div className="headerTitleLine"></div>
                  <h1 className="page-title kla">{section.title}</h1>
                </div>
              )}

              <div
                className={`left-content ${
                  section.title === "Këshilli i Lartë i Arkivave"
                    ? "kla"
                    : section.title ===
                      "Komisioni i Deklasifikimit dhe Zhvlerësimit të Informacionit të klasifikuar Sekret Shtetëror"
                    ? "kdzh"
                    : "kqe"
                }`}
              >
                {section.leftContent}
              </div>
              <div
                className={`right-content ${
                  section.title === "Këshilli i Lartë i Arkivave"
                    ? "kla"
                    : section.title ===
                      "Komisioni i Deklasifikimit dhe Zhvlerësimit të Informacionit të klasifikuar Sekret Shtetëror"
                    ? "kdzh"
                    : "kqe"
                }`}
              >
                {Array.isArray(section.rightContent) &&
                  section.rightContent.map((member, index) => (
                    <div className="council-member" key={index}>
                      <div className="member-image">
                        <img src={member.image} alt={member.name} />
                      </div>
                      <div className="member-info">
                        <p className="member-name">{member.name}</p>
                        <p className="member-institution">
                          {member.institution}
                        </p>
                      </div>
                    </div>
                  ))}
              </div>
            </div>
          ))}
        </>
      );
    } else if (
      pagePath.pathname === "/drejtoria/organizimi-i-rrjetit-arkivor"
    ) {
      return (
        <div className="page-content-ra">
          <div className="left-content-ra">{pageData.leftContent}</div>
          <div className="right-content-ra">
            <div className="right-content-ra-title">
              Fondi Arkivor i Republikës së Shqipërisë ruhet, përpunohet,
              administrohet dhe shërbehet nga rrjeti arkivor i Republikës së
              Shqipërisë.
              <br />
              Rrjeti arkivor i Republikës së Shqipërisë përbëhet nga:
            </div>
            {Array.isArray(pageData.rightContent) &&
              pageData.rightContent.map((section, index) => (
                <div key={index} className="rrjeti-arkivor">
                  <div className="right-title">{section.title}</div>
                  <p className="right-subtitle">{section.subtitle}</p>
                  <ul>
                    {Array.isArray(section.list) &&
                      section.list.map((item, itemIndex) =>
                        typeof item === "string" ? (
                          <p key={itemIndex} className="private">
                            {item}
                          </p>
                        ) : (
                          <li key={itemIndex}>
                            <a
                              href={item.url}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              {item.name}
                            </a>
                          </li>
                        )
                      )}
                  </ul>
                </div>
              ))}
          </div>
        </div>
      );
    } else if (isStrukturaPath) {
      return (
        <div className="page-content-struktura">
          <div className="left-content-struktura">
            {leftItems.map((item, index) => (
              <div key={index} className="struktura-item">
                <Link
                  to={item.path || "#"}
                  className={`list-title ${
                    item.path === "" ? "none" : "underline"
                  }`}
                >
                  {item.name}
                </Link>
                <ul>
                  {item.sektoret.map((sector, subIndex) => (
                    <li key={subIndex}>
                      <Link to={sector.path}>{sector.name}</Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
          <div className="right-content-struktura">
            {rightItems.map((item, index) => (
              <div key={index} className="struktura-item">
                <Link
                  to={item.path || "#"}
                  className={`list-title ${
                    item.path === "" ? "none" : "underline"
                  }`}
                >
                  {item.name}
                </Link>
                <ul>
                  {item.sektoret.map((sector, subIndex) => (
                    <li key={subIndex}>
                      <Link to={sector.path}>{sector.name}</Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      );
    }

    return <div>No content available</div>;
  };

  return (
    <div className="page">
      <div className="page-header">
        <div className="headerTitleLine"></div>
        <h1 className="page-title">{pageData.title}</h1>
      </div>
      {renderPageContent()}
      {isModalOpen && (
        <div className="modal-post-historiku">
          <button className="modal-close-historiku" onClick={closeModal}>
            &times;
          </button>
          <button className="modal-prev-post-historiku" onClick={prevSlide}>
            &#10094;
          </button>
          <div className="modal-content-post-historiku">
            <img
              src={historikuImages[currentImageIndex]}
              alt={`Slide ${currentImageIndex + 1}`}
            />
          </div>
          <button className="modal-next-post-historiku" onClick={nextSlide}>
            &#10095;
          </button>
        </div>
      )}
    </div>
  );
};

export default Drejtoria;
